import { useEffect } from "react";
import { useLocation } from "react-router-dom";

type Props = {
  behavior?: ScrollBehavior;
};

export default function ScrollToTop({ behavior = "smooth" }: Props) {
  const { pathname } = useLocation();

  useEffect(() => {
    // scroll to top when the pathname changes
    window.scrollTo({ top: 0, left: 0, behavior });
  }, [pathname, behavior]);

  return null;
}